// extracted by mini-css-extract-plugin
export default {"subTitle":"ReturnAddItem_subTitle__eVh+n","divider":"ReturnAddItem_divider__Ra6OO"};